import BaseComponent from "../../form_components/BaseComponent";
import Textarea from "../../form_components/Textarea";
import Input from "../../form_components/Input";
import Dropdown from "../../form_components/Dropdown";
import _ from "lodash";
import { updateTree } from "@app/utilities";
export default class CommonModuleWizardDialog extends BaseComponent {
    /**
     * Submenu view for argument definition lists (inputs)
     * @module CommonModuleWizardDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            modName: this.getModuleName(this.props.como),
            attempts: this.getNumberOfAttempts(this.props.rootModule),
            inputType: this.props.wizardConfig.inputType,
            expectedIntentSelection: this.props.wizardConfig.expectedIntent,
            initialPrompt: this.getInitialPrompt(this.props.wizardConfig, this.props.prompts),
            invalidPrompt: this.getInvalidPrompt(this.props.wizardConfig, this.props.prompts),
            rePrompt: this.getRePrompt(this.props.wizardConfig, this.props.prompts),
            confirmPrompt: this.getConfirmPrompt(this.props.wizardConfig, this.props.prompts),
            intentOptions: this.props.como.components.intents
        }
        this.addHandle = this.handleAdd.bind(this);
        this.updateCommonModule = this.handleUpdate.bind(this);

    }
    handleAdd() {
        this.updatePromptText(this.state.initialPrompt, this.props.como);
        this.updatePromptText(this.state.invalidPrompt, this.props.como);
        this.updatePromptText(this.state.rePrompt, this.props.como);
        this.updatePromptText(this.state.confirmPrompt, this.props.como);
        this.updateModuleName(this.state.modName, this.props.como);
        this.props.apm.commonModuleManager.importCommonModule(this.props.como);
        this.props.closeWizardDialog();
    }
    handleUpdate() {
        this.props.apm.serialized.components.modules.forEach(module => {
            if (module.id === this.props.appComo.id && module.name !== this.state.modName) {
                module.name = this.state.modName;
                module.props.lastLocalChange = this.props.apm.timestamp;
                //if wizard config is opened from application panel, parent node will be selected Js tree needs refresh in that case
                updateTree();
                // at this point property panel will be open property panel needs 
                document.dispatchEvent(new CustomEvent("ev-property-refresh"));
            }
            module.versions[1].flow.nodes.forEach(node => {
                switch (node.props.parentComponentID) {
                    case this.state.initialPrompt.id:
                        if (node.props.config.text['en-US'] !== this.state.initialPrompt.props.config.text['en-US']) {
                            node.props.config.text['en-US'] = this.state.initialPrompt.props.config.text['en-US'];
                            node.props.lastLocalChange = this.props.apm.timestamp;
                        }
                        break;
                    case this.state.invalidPrompt.id:
                        if (node.props.config.text['en-US'] !== this.state.invalidPrompt.props.config.text['en-US']) {
                            node.props.config.text['en-US'] = this.state.invalidPrompt.props.config.text['en-US'];
                            node.props.lastLocalChange = this.props.apm.timestamp;
                        }
                        break;
                    case this.state.rePrompt.id:
                        if (node.props.config.text['en-US'] !== this.state.rePrompt.props.config.text['en-US']) {
                            node.props.config.text['en-US'] = this.state.rePrompt.props.config.text['en-US'];
                            node.props.lastLocalChange = this.props.apm.timestamp;
                        }
                        break;
                    case this.state.confirmPrompt.id:
                        if (node.props.config.text['en-US'] !== this.state.confirmPrompt.props.config.text['en-US']) {
                            node.props.config.text['en-US'] = this.state.confirmPrompt.props.config.text['en-US'];
                            node.props.lastLocalChange = this.props.apm.timestamp;
                        }
                        break;
                    case this.props.appComo.id:
                        if (node.name !== this.state.modName) {
                            node.name = this.state.modName;
                            node.props.lastLocalChange = this.props.apm.timestamp;
                        }
                        break;
                        case this.props.appComo.id:
                            node.name=this.state.modName;
                            node.props.lastLocalChange = this.props.apm.timestamp;
                            break;
                }
            })
        });
        this.props.serialized.components.objects.forEach(object => {
            switch (object.id) {
                case this.state.initialPrompt.id:
                    if (object.props.config.text['en-US'] !== this.state.initialPrompt.props.config.text['en-US']) {
                        object.props.config.text['en-US'] = this.state.initialPrompt.props.config.text['en-US'];
                        object.props.lastLocalChange = this.props.apm.timestamp;
                    }
                    break;
                case this.state.invalidPrompt.id:
                    if (object.props.config.text['en-US'] !== this.state.invalidPrompt.props.config.text['en-US']) {
                        object.props.config.text['en-US'] = this.state.invalidPrompt.props.config.text['en-US'];
                        object.props.lastLocalChange = this.props.apm.timestamp;
                    }
                    break;
                case this.state.rePrompt.id:
                    if (object.props.config.text['en-US'] !== this.state.rePrompt.props.config.text['en-US']) {
                        object.props.config.text['en-US'] = this.state.rePrompt.props.config.text['en-US'];
                        object.props.lastLocalChange = this.props.apm.timestamp;
                    }
                    break;
                case this.state.confirmPrompt.id:
                    if (object.props.config.text['en-US'] !== this.state.confirmPrompt.props.config.text['en-US']) {
                        object.props.config.text['en-US'] = this.state.confirmPrompt.props.config.text['en-US'];
                        object.props.lastLocalChange = this.props.apm.timestamp;
                    }
                    break;
            }
        })
        //re-rendering settings to update prompt text in locale
        this.props.apm.reactDOMComponents.render({ name: 'SettingWidget', props: { serialized: this.props.serialized }, $el: $('#settings') });
        this.props.closeWizardDialog();
    }
    /*
    *
    *
    */
    getModuleName(como) {
        if (!this.props.isNewElement) {
            return this.props.appComo.name;
        }
        return como.application;
    }
    updateModuleName(modName, como) {
        como.application = modName;
        return como;
    }

    componentDidMount() {
        document.addEventListener("ev-wizard-dialog-add", this.addHandle);
        document.addEventListener("ev-wizard-dialog-wizard", this.updateCommonModule);
    }
    componentWillUnmount() {
        document.removeEventListener("ev-wizard-dialog-add", this.addHandle);
        document.removeEventListener("ev-wizard-dialog-wizard", this.updateCommonModule);

    }
    /*
    *
    *returns number of attempts
    */
    getNumberOfAttempts(rootModule) {
        const localVariables = rootModule.localVariables ? rootModule.localVariables : [];
        const maxAttemptsVariable = localVariables.find(l => l.name === "maxAttempts");
        if (maxAttemptsVariable) {
            return maxAttemptsVariable.props.config.defaultValue ? maxAttemptsVariable.props.config.defaultValue : "3";
        }
    }
    /*
    *
    *returns the inputtype from input node;
    */
    getInputType(rootModule) {
        //assuming common module has only 1 input in root module
        const input = rootModule.versions[1].flow.nodes.filter(n => n.props.nodeTypeName === "Input")[0];
        if (input) {
            return input.props.config.inputType || '';
        }
    }
    /*
    *get the initial prompt from start module 
    */
    getInitialPrompt(wizardConfig, prompts) {
        const initialPrompt = prompts.find(n => n.id === wizardConfig.initialPrompt);
        if (!this.props.isNewElement) {
            const initialAppPrompt = this.props.appPrompts.find(p => p.name === initialPrompt.name);
            return initialAppPrompt ? initialAppPrompt : {};
        }
        return initialPrompt ? initialPrompt : {};
    }
    /*
    *
    */
    getInvalidPrompt(wizardConfig, prompts) {
        const invalidPrompt = prompts.find(n => n.id === wizardConfig.invalidPrompt);
        if (!this.props.isNewElement) {
            const invalidAppPrompt = this.props.appPrompts.find(p => p.name === invalidPrompt.name);
            return invalidAppPrompt ? invalidAppPrompt : {};
        }
        return invalidPrompt ? invalidPrompt : {};
    }
    /*
    */
    getRePrompt(wizardConfig, prompts) {
        const rePrompt = prompts.find(n => n.id === wizardConfig.rePrompt);
        if (!this.props.isNewElement) {
            const reAppPrompt = this.props.appPrompts.find(p => p.name === rePrompt.name);
            return reAppPrompt ? reAppPrompt : {};
        }
        return rePrompt ? rePrompt : {};

    }
    /*
    *
    */
    getConfirmPrompt(wizardConfig, prompts) {
        const confirmPrompt = prompts.find(n => n.id === wizardConfig.confirmPrompt);
        if (!this.props.isNewElement) {
            const confirmAppPrompt = this.props.appPrompts.find(p => p.name === confirmPrompt.name);
            return confirmAppPrompt ? confirmAppPrompt : {};
        }
        return confirmPrompt ? confirmPrompt : {};
    }/*
*
*/


    /**
   * Set config proxy; catches own input value updates and update its data model before saving to list
   * @param {string} key
   * @param {string|boolean} value
   */
    setConfig(key, value) {
        if (key === "modName") {
            this.setState({ "modName": value });
        }
        if (key === "initialPrompt") {
            _.set(this.state.initialPrompt, ['props', 'config', 'text', 'en-US'], value);
            this.setState({ initialPrompt: this.state.initialPrompt });
        }
        if (key === "invalidPrompt") {
            _.set(this.state.invalidPrompt, ['props', 'config', 'text', 'en-US'], value);
            this.setState({ invalidPrompt: this.state.invalidPrompt });
        }
        if (key === "rePrompt") {
            _.set(this.state.rePrompt, ['props', 'config', 'text', 'en-US'], value);
            this.setState({ rePrompt: this.state.rePrompt });
        }
        if (key === "confirmPrompt") {
            _.set(this.state.confirmPrompt, ['props', 'config', 'text', 'en-US'], value);
            this.setState({ confirmPrompt: this.state.confirmPrompt });
        }

    }
    /**
    * Get config proxy
    * @param {string} key
    * @returns {string}
    */
    getConfig(key) {
        return this.state[key];
    }
    //updating the prompt text to the data updated in UI
    updatePromptText(prompt) {
        this.props.como.components.objects.forEach(ob => {
            if (ob.id === prompt?.props?.parentComponentID) {
                ob.props.config.text['en-US'] = prompt.props.config.text['en-US'];
            }
        })
        this.props.como.components.modules.forEach(mo => {
            mo.versions[1].flow.nodes.forEach(n => {
                if (n.props.parentComponentID === prompt.id) {
                    _.set(n, ['props', 'config', 'text', 'en-US'], prompt?.props?.config?.text?.['en-US'] || '');
                }
            })

        })
        return this.props.como
    }
    getTabs() {
        return (
            <ul className="nav nav-tabs ">
                <li className="nav-button active" style={{ paddingLeft: 0 }}>
                    <a data-toggle="tab" href="#basic" className="new_intent">{"basic"}</a>
                </li>
                <li><div className="break" /></li>
                <li className="nav-button">
                    <a data-toggle="tab" href="#prompts" className="new_module">{"prompts"}</a>
                </li>
            </ul>
        )

    }
    renderElements(type) {
        const inputTypes = this.props.apm.knowledgeBase.getInputTypes();
        const inputTypeSelection = inputTypes.findIndex(ip => ip.value === this.state.inputType);
        const expectedIntentSelection = this.props.apm.knowledgeBase.getIndexFromValue(this.state.expectedIntent, this.state.intentOptions);
        if (type === "basicComo") {
            return (<div>
                <Input label="Module Name"
                    valRules={{ "noEmpty": true, "objectName": true, }}
                    context={this}
                    valKey={"modName"}
                    value={this.state.modName}
                    suppressUpdate={true} />
                <Input label="Attempts"
                    context={this}
                    valKey={"attempts"}
                    value={this.state.attempts}
                    disabled={true}
                    suppressUpdate={true} />
                <Dropdown wide={false}
                    valKey={"inputType"}
                    label={"Input Type"}
                    optionName={"Input Type"}
                    options={inputTypes}
                    selection={inputTypeSelection}
                    readOnly={true}
                    suppressUpdate={true} />
                <Dropdown wide={false}
                    valKey={"expectedIntent"}
                    label={"Expected Intent"}
                    optionName={"Expected Intent"}
                    options={this.state.intentOptions}
                    selection={expectedIntentSelection}
                    readOnly={true}
                    suppressUpdate={true} />
            </div>)
        }
        if (type === "prompts") {
            return (<div>
                <Textarea
                    label={`Initial Prompt: ${this.state.initialPrompt.name}`}
                    valKey={"initialPrompt"}
                    valRules={{ "noEmpty": true }}
                    context={this}
                    suggestion={"variable"}
                    value={this.state.initialPrompt.props && this.state.initialPrompt.props.config && this.state.initialPrompt.props.config.text['en-US']}
                    suppressUpdate={true} />
                <Textarea
                    label={`Invalid Prompt: ${this.state.invalidPrompt.name}`}
                    valKey={"invalidPrompt"}
                    valRules={{ "noEmpty": true }}
                    context={this}
                    value={this.state.invalidPrompt.props && this.state.invalidPrompt.props.config && this.state.invalidPrompt.props.config.text['en-US']}
                    suppressUpdate={true} />
                <Textarea label={`Reprompt: ${this.state.rePrompt.name}`}
                    valRules={{ "noEmpty": true }}
                    context={this}
                    valKey={"rePrompt"}
                    value={this.state.rePrompt.props && this.state.rePrompt.props.config && this.state.rePrompt.props.config.text['en-US']}
                    suppressUpdate={true} />
                <Textarea label={`Confirm Prompt:${this.state.confirmPrompt.name}`}
                    valRules={{ "noEmpty": true }}
                    context={this}
                    valKey={"confirmPrompt"}
                    value={this.state.confirmPrompt.props && this.state.confirmPrompt.props.config && this.state.confirmPrompt.props.config.text['en-US']}
                    suppressUpdate={true} />
            </div>)
        }
    }
    /**
     * React render
     * @returns {XML}
     */
    render() {

        return (
            <div className="container-fluid element-dialog">
                <div className={"row"}>
                    <div className="tab-title col-md-12">
                        <ul className="nav nav-tabs ">
                            <li className="nav-button active" style={{ paddingLeft: 0 }}>
                                <a data-toggle="tab" href="#basicComo" >{"BASIC"} </a>
                            </li>
                            <li><div className="break" /></li>
                            <li className="nav-button">
                                <a data-toggle="tab" href="#prompts" >{"PROMPTS"}</a>
                            </li>
                        </ul>
                    </div>
                    <div className="tab-content col-md-12">
                        <div id="basicComo" className="tab-pane fade in active">
                            {this.renderElements("basicComo")}
                        </div>
                        <div id="prompts" className="tab-pane fade">
                            {this.renderElements("prompts")}
                        </div>

                    </div>
                </div>

            </div>
        );
    }
}
